/**
 * Shown when no Azure app-registration client ID is configured. Prevents the
 * confusing AADSTS700016 ("application 'undefined' was not found") error by
 * blocking sign-in and telling the admin exactly what to set.
 */
export function SetupNotice() {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173';
  const redirect = `${origin}/blank.html`;

  return (
    <section className="consent">
      <span className="consent__badge">Setup required</span>
      <h1 className="consent__h1">Connect an app registration to continue</h1>
      <p className="consent__lede">
        This tool is a public client — it signs in with your own delegated admin token and has no
        backend. It just needs the Application (client) ID of a Microsoft Entra app registration.
        No client secret is ever used or stored.
      </p>

      <div className="notice notice--warn" role="alert">
        <strong>Missing configuration: VITE_AAD_CLIENT_ID</strong>
        <p>Sign-in is disabled until a real client ID is supplied. Right now the app has no ID to send
          to Microsoft Entra, which is what causes the “application ‘undefined’ was not found” error.</p>
      </div>

      <h2 className="consent__h2">1 · Register a multi-tenant SPA</h2>
      <p className="consent__why">
        In the Entra admin center → App registrations → New registration. Choose
        “Accounts in any organizational directory (multitenant)”. Under Authentication, add a
        <strong> Single-page application</strong> platform with this redirect URI:
      </p>
      <code className="consent__scopes">{redirect}</code>

      <h2 className="consent__h2">2 · Set the client ID</h2>
      <p className="consent__why">
        Copy the app’s <strong>Application (client) ID</strong>, then create a
        <code> .env</code> file at the repo root (copy <code>.env.example</code>) with:
      </p>
      <code className="consent__scopes">VITE_AAD_CLIENT_ID=&lt;your-application-client-id&gt;</code>
      <p className="consent__fineprint">
        Restart <code>npm run dev</code> after editing <code>.env</code>. For a deployed build, set
        <code> VITE_AAD_CLIENT_ID</code> in your static host’s build environment (Azure Static Web
        Apps / Cloudflare Pages) — Vite inlines it at build time, so it must be present when the
        bundle is built, not just at runtime.
      </p>
    </section>
  );
}
